import { FaDownload } from "react-icons/fa";

import { Icon } from "@chakra-ui/react";

export function IconeDownload() {
  return (
    <Icon
      aria-label="Download"
      color="#006064"
      as={FaDownload}
      boxSize="18px"
      _hover={{ cursor: "pointer" }}
    />
  );
}
